import { apiClient } from "@/lib/api-client";
import type { ApiResponse } from "@/types/api";
import type { ScheduleValidationIssue } from "../types";

export async function listScheduleIssues(
  scheduleId: string,
  toleranceMinutes = 0,
): Promise<ScheduleValidationIssue[]> {
  // A positive tolerance hides student time conflicts of <= N minutes (the
  // "accept small overlaps" view). 0 / omitted is the strict, historical list.
  const response = await apiClient.get<ApiResponse<ScheduleValidationIssue[]>>(
    `/schedules/${scheduleId}/issues`,
    toleranceMinutes > 0 ? { params: { toleranceMinutes } } : undefined,
  );
  if (response.data.success) {
    return response.data.data;
  }
  throw new Error(response.data.message || "Failed to load schedule issues");
}
